import {Injectable} from '@angular/core';

export interface DraftTurnOptions {
  webSearch: boolean;
  includeResources: boolean;
  includeImages: boolean;
}

export interface DraftFirstTurn extends DraftTurnOptions {
  message: string;
}

/** Hands chosen files (by document id) and the first turn (by draft id) to the draft page, in memory. */
@Injectable({providedIn: 'root'})
export class DraftUploadService {
  private readonly pending = new Map<string, File>();
  private readonly firstTurns = new Map<string, DraftFirstTurn>();

  hold(documentId: string, file: File): void {
    this.pending.set(documentId, file);
  }

  take(documentId: string): File | null {
    const file = this.pending.get(documentId) ?? null;
    this.pending.delete(documentId);
    return file;
  }

  /** What the create dialog asked for, sent as the first turn once the draft page is ready. */
  holdFirstTurn(draftId: string, turn: DraftFirstTurn): void {
    this.firstTurns.set(draftId, turn);
  }

  takeFirstTurn(draftId: string): DraftFirstTurn | null {
    const turn = this.firstTurns.get(draftId) ?? null;
    this.firstTurns.delete(draftId);
    return turn;
  }
}
